<div class="headermi boc-page-header">
    <div class="btnsavemi ui-btn ui-btn--primary ui-btn--auto">
      <i class="fas fa-save"></i>&nbsp; Sauvegarder
    </div>
    <div class="blocmodifuser"></div>
</div>
<div class="contblocmi">
  <div class="ui-card blocmi">
    <div class="hbmi"><i class="fa-duotone fa-light fa-user icduotone"></i> &nbsp;Informations personnelles</div>
    <div class="ui-card__body">
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Prenom :
        </div>
        <input type="text" class="inmi" id="infirstname" placeholder="Prenom / Nom">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Nom :
        </div>
        <input type="text" class="inmi" id="inlastname" placeholder="Prenom / Nom">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Adresse e-mail de contact :
        </div>
        <input type="text" class="inmi" id="inmail" placeholder="exemple@exemple.com">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          N de telephone de contact :
        </div>
        <input type="text" class="inmi" id="intel" placeholder="ex : 06 07 08 09 10">
      </div>
    </div>
  </div>
  <div class="ui-card blocmi">
    <div class="hbmi"><i class="fa-duotone fa-light fa-file-contract icduotone"></i> &nbsp;Informations legales</div>
    <div class="ui-card__body">
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Nom de l'organisateur :
        </div>
        <input type="text" class="inmi" id="inorganame" placeholder="Ex : denomination sociale / nom de l'entreprise">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Forme juridique :
        </div>
       <select class="ui-select inmi inselinf" id="informejur">
          <option value="particulier">Particulier</option>
          <option value="association">Association</option>
          <option value="auto-entrepreneur">Auto-entrepreneur</option>
          <option value="ei">EI</option>
          <option value="eirl">EIRL</option>
          <option value="eurl">EURL</option>
          <option value="geie">GEIE</option>
          <option value="gie">GIE</option>
          <option value="sarl">SARL</option>
          <option value="sa">SA</option>
          <option value="sas">SAS</option>
          <option value="sasu">SASU</option>
          <option value="sa">SA</option>
          <option value="sc">SC</option>
          <option value="scs">SCS</option>
          <option value="snc">SNC</option>
          <option value="autre">Autre</option>
       </select>
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Siege sociale :
        </div>
        <input type="text" class="inmi" id="inadress" placeholder="Ex : 22 avenue Auguste Renoir, Cagnes, 06800">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          N de TVA intracommunautaire :
        </div>
        <input type="text" class="inmi" id="intva" placeholder="Ex : FR12 342 222 658">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          N de licence d'entrepreneur du spectacle :
        </div>
        <input type="text" class="inmi" id="inlicence" placeholder="Ex : 12345678912345">
      </div>
    </div>
  </div>
  <div class="ui-card blocmi" style="margin-bottom:300px;">
    <div class="hbmi"><i class="fa-duotone fa-light fa-piggy-bank icduotone"></i> &nbsp;Informations bancaires</div>
    <div class="ui-card__body">
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          Titulaire du compte :
        </div>
        <input type="text" class="inmi" id="inownerbank" placeholder="Nom / prenom">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          IBAN :
        </div>
        <input type="text" class="inmi" id="iniban" placeholder="Ex : FR76 1234 5678 1234 5678">
      </div>
      <div class="ui-form-group liformi">
        <div class="ui-form-label labelmi">
          BIC :
        </div>
        <input type="text" class="inmi" id="inbic" placeholder="Ex : CMC0012345678">
      </div>
    </div>
  </div>
</div>
<div class="bloctxtmi">
  <div style="font-size:35px;height:70px;line-height:70px;opacity:0.6;margin-top:20px;">
    <i class="fa-duotone fa-light fa-circle-info"></i>
  </div>
  <div style="margin-left:6%;width:88%;margin-top:12px;">
    Les informations demandees sont requises afin que nous puissions effectuer les versements des fonds de votre billetterie en ligne.
    <br><br>
    En renseignant ces champs vous certifiez l'exactitude des informations transmises.
  </div>
</div>